import classnames from 'classnames'
import React from 'react'
import Spinner from '../Spinner/Spinner'
import style from './styles/select.module.scss'

const SelectPlaceholder = ({ label, ...props }): React.ReactElement => {
  return (
    <div className={classnames(style.placeholder, props.className)}>
      <div className={classnames(style.placeholder__label)}>{label}</div>
      <div className={style.placeholder__block}>
        <Spinner color='red' />
      </div>
    </div>
  )
}

export default SelectPlaceholder
